import Container from "@components/Atomic/Container/Container";
import { Image } from "@components/Image/Image";
import { StyledContainer } from "@components/Styled/Container";
import React from "react";
import SwiperCore, { Pagination } from "swiper";
import { SwiperSlide } from "swiper/react";
import { withImageCarousel } from "./withImageCarousel";

import { clsx } from "clsx";

import Swiper from "@components/Swiper/Swiper";

SwiperCore.use([Pagination]);

const Wrapper = (props: any) => (
  <StyledContainer {...props} className={clsx(props.className, "relative")} />
);

const ImageCarousel = withImageCarousel(({ images, onClickImage, styles }) => (
  <Container
    className="bg-neutral pb-giga"
    styles={styles}
    data-component-type="section-image-carousel"
  >
    <Wrapper width="full">
      <Swiper
        slidesPerView={2.2}
        lazy={true}
        preloadImages={false}
        pagination={{ clickable: true }}
        observer={true}
        observeParents={true}
        breakpoints={{
          320: {
            slidesPerView: 2.2,
            observer: true,
            observeParents: true,
          },
        }}
      >
        {images?.map((image, index) => {
          return (
            <SwiperSlide key={index} data-testid="image-carousel-swiper">
              <Image
                image={image}
                alt={image?.alt}
                ratio="4/5"
                onClick={onClickImage}
                imageLink={image?.imageLink}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </Wrapper>
  </Container>
));

export default ImageCarousel;
